module.exports = __webpack_public_path__ + "img/google_play.67fa18f6.png";